const d = new Date();
const year = d.getFullYear();

// 16 serie: 4 periodi × (MMP base + 3 soglie kjoule)
// Indice = kj_group_start + period_offset
// kj_group_start: 0=MMP, 4=1000kJ, 8=2000kJ, 12=3000kJ
// period_offset:  0=oggi, 1=3mesi, 2=anno, 3=alltime
export const SERIES_CONFIG = [
    // MMP base (idx 0-3)
    { label: 'Oggi',              color: '#000000', dash: [],       periodo: 'oggi',    soglia_kj: 0    },
    { label: '3 mesi',            color: '#e6c84a', dash: [],       periodo: '3mesi',   soglia_kj: 0    },
    { label: `${year}`,           color: '#4cbcbe', dash: [],       periodo: 'anno',    soglia_kj: 0    },
    { label: 'All Time',          color: '#6dc96b', dash: [],       periodo: 'alltime', soglia_kj: 0    },
    // >1000 kJ (idx 4-7)
    { label: '>1000 kJ',          color: '#e67e22', dash: [2, 2],   periodo: 'oggi',    soglia_kj: 1000 },
    { label: '>1000 kJ 3m',       color: '#eeab6f', dash: [2, 2],   periodo: '3mesi',   soglia_kj: 1000 },
    { label: `>1000 kJ ${year}`,  color: '#f5cba7', dash: [2, 2],   periodo: 'anno',    soglia_kj: 1000 },
    { label: '>1000 kJ All Time', color: '#f8dec8', dash: [2, 2],   periodo: 'alltime', soglia_kj: 1000 },
    // >2000 kJ (idx 8-11)
    { label: '>2000 kJ',          color: '#2980b9', dash: [2, 2],   periodo: 'oggi',    soglia_kj: 2000 },
    { label: '>2000 kJ 3m',       color: '#74acd2', dash: [2, 2],   periodo: '3mesi',   soglia_kj: 2000 },
    { label: `>2000 kJ ${year}`,  color: '#a9cce3', dash: [2, 2],   periodo: 'anno',    soglia_kj: 2000 },
    { label: '>2000 kJ All Time', color: '#cadfee', dash: [2, 2],   periodo: 'alltime', soglia_kj: 2000 },
    // >3000 kJ (idx 12-15)
    { label: '>3000 kJ',          color: '#8e44ad', dash: [2, 2],   periodo: 'oggi',    soglia_kj: 3000 },
    { label: '>3000 kJ 3m',       color: '#b585ca', dash: [2, 2],   periodo: '3mesi',   soglia_kj: 3000 },
    { label: `>3000 kJ ${year}`,  color: '#d2b4de', dash: [2, 2],   periodo: 'anno',    soglia_kj: 3000 },
    { label: '>3000 kJ All Time', color: '#e2d0ea', dash: [2, 2],   periodo: 'alltime', soglia_kj: 3000 },
];

export const KJ_GROUPS = [
    { start: 4,  label: '>1000 kJ' },
    { start: 8,  label: '>2000 kJ' },
    { start: 12, label: '>3000 kJ' },
];

export const PERIOD_LABELS = ['Oggi', '3 mesi', `${year}`, 'All Time'];

export const VALORI_KEYS = [
    'valoriAttuali', 'valoriStorici', 'valoriStoriciBestAnno', 'valoriStoriciBestAllTime',
    'valoriAttuali1000', 'valoriStorici1000', 'valoriStoriciBestAnno1000', 'valoriStoriciBestAllTime1000',
    'valoriAttuali2000', 'valoriStorici2000', 'valoriStoriciBestAnno2000', 'valoriStoriciBestAllTime2000',
    'valoriAttuali3000', 'valoriStorici3000', 'valoriStoriciBestAnno3000', 'valoriStoriciBestAllTime3000',
];

export function makeData(raw, sport, modo) {
    if (!raw || !raw.length) return [];
    if (sport === 'PODISMO') {
        return raw.filter(el => el.x && el.y)
            .map(el => ({ x: el.x, y: el.y / (el.x / 1000) }));
    }
    if (modo === 'watt_kg') {
        return raw.filter(el => el.x && el.dettaglio != null)
            .map(el => ({ x: el.x, y: el.dettaglio }));
    }
    return raw.filter(el => el.x && el.y);
}

export function formatY(value, sport, modo) {
    if (value == null) return null;
    if (sport === 'PODISMO') {
        if (value <= 0) return null;
        const mins = String(Math.floor(value / 60)).padStart(2, '0');
        const secs = String(Math.round(value % 60)).padStart(2, '0');
        return `${mins}:${secs}`;
    }
    if (modo === 'watt_kg') return Number(value).toFixed(1);
    return String(Math.round(value));
}
